import { useMutation, useQuery } from '@tanstack/react-query';
import { getObsazeniNahled, getObsazeniProPoplach } from './ObsazeniService';
import { ObsazeniNahledRequest, ObsazeniVysledek } from '../generated/models/Obsazeni';

export const useObsazeniNahledMutation = () =>
    useMutation<ObsazeniVysledek, Error, ObsazeniNahledRequest>({
        mutationFn: (data) => getObsazeniNahled(data),
    });

export const useObsazeniProPoplachQuery = (poplachId: number, enabled: boolean) =>
    useQuery<ObsazeniVysledek, Error>({
        queryKey: ['obsazeni', poplachId],
        queryFn: () => getObsazeniProPoplach(poplachId),
        enabled,
    });
